/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'wafPolicy';
const componentName = 'waf-policy-custom-preview';
const prefix = `${moduleName}.${componentName}`;

export const wafPolicyLabel = `${prefix}.wafPolicyLabel`;
export const evaluationModeStatusText = `${prefix}.evaluationModeStatusText`;

export const ENGLISH = {
    [wafPolicyLabel]: 'WAF Policy',
    [evaluationModeStatusText]: 'Evaluation Mode',
};
